<template>
    <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card v-if="!editPassword">
          <vs-row vs-justify="center" :v-if="!edit">
            <vs-avatar v-if="user.image == '' || user.image == null" size="70px" :src="require('@/assets/images/users/3.png')" />
            <vs-avatar v-else :src="baseUrl+user.image" size="70px" />
          </vs-row>
          <vs-row>
            <form @submit.prevent="btnEditProfile">
          <vs-col>
              <vs-input required label="Name" :disabled="!edit" v-model="user.name" />
            </vs-col>
            <vs-col>
              <vs-input required type="number" :disabled="!edit" label="Phone" v-model="user.phone" />
            </vs-col>
            <vs-col>
              <vs-input required label="Country" :disabled="!edit" v-model="user.country" />
            </vs-col>
            <vs-col>
              <vs-input required label="Email" disabled="true" v-model="user.email" />
            </vs-col>
            <vs-col  v-show="edit">
             <uploader v-if="edit"
                label="Update Profile Image (Try to use square image Please Don't Upload Video)"
                v-model="user.image"
                :profile="true"
                :file="user.image"
              />
            </vs-col>
            <vs-col>
              <vs-button v-if="edit" button="submit">Submit</vs-button>
            </vs-col>
            </form>
            
          </vs-row>
        </vs-card>
          <vs-row v-else>
            <change-password @passwordUpdated="editPassword = false"></change-password> 
          </vs-row>
          <vs-row v-if="!edit && !editPassword"> 
            <vs-col vs-lg="3">
              <vs-button v-if="!edit" button="button" @click="edit=true">Edit Profile</vs-button>
            </vs-col>
            <vs-col vs-lg="4">
              <vs-button v-if="!edit" button="button" @click="editPassword=true">Change Password</vs-button>
            </vs-col>
          </vs-row>  
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import Uploader from "../common/uploader.vue";
import ChangePassword from './changePassword.vue';
export default {
  name:"edit-profile",
  components: {
    Uploader,
    ChangePassword
  },
  data(){
    return{
      edit: false,
      user: JSON.parse(localStorage.user),
      action: "View",
      editPassword:false,
    baseUrl: API.API_BASE.substring(0, API.API_BASE.lastIndexOf("/")) + "/",
    }
  },
  watch:{
    'localStorage.user'(){
      this.user = JSON.parse(localStorage.user);
    },
    edit(val){
      this.action = val? "Edit" : "View";
      this.$emit("actionUpdate", this.action);
    }
  },
  mounted(){
      this.edit= false;
      this.user= JSON.parse(localStorage.user);
      this.action= "View";
      this.editPassword=false;
  },
  methods:{
    reset(){
      this.$emit("closeEdit")
      // destroy the vue listeners, etc
      this.$destroy();

      // remove the element from the DOM
      this.$el.parentNode.removeChild(this.$el);
    },
    btnEditProfile(){
      api
        .put(
          API.EDIT_PROFILE,
          this.user
        )
        .then(r => {    
          if (r.status !== 200) {        
            this.$vs.notify({
              title: "Active toggle failed",
              text: "User couldn't be modified",
              color: "danger",
              position: "top-right"
            });
          }
          else{
            this.$vs.notify({
              title: "Success",
              text: "Profile updated successfully",
              color: "success",
              position: "top-right",
            });
            this.$ls.set("user", JSON.stringify(r.data));
            this.edit = false;
            this.$emit("profileUpdated");
          }
        })
        .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.response.data.message,
              color: "danger",
              position: "top-right"
            });
          });
      
    },
    enableEdit(){
      this.edit=true;

    }
  }
}
</script>